import {RootStore} from '../../stores/RootStore';

export const publishRelatedProductsEvent = (rootStore: RootStore): void => {
  return rootStore.ecomPublicApi.product.publishRelatedProducts([rootStore.$state.product.id]);
};
